import mustache from "mustache";
import { procedimientoVeterinarioGrpcCatalogService } from "../../../../../modulos/catalogos/pesaje/ganaderia/services/ProcedimientoVeterinarioGrpcCatalogService";
import { RotacionPesajeVeterinariaResponse } from "../../../../../modulos/pesaje/ganaderia/response/RotacionPesajeVeterinariaResponse";
import { formatFechaCorta } from "../../../../../utils/fechaUtils";
import { _2d, _miles } from "../../../../../utils/numberUtils";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import template from "./rotacionPesajeVeterinariaDetailTemplate.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let ROTACION_PESAJE_VETERINARIA_DETAIL_ID = 0;

/** Detalle de solo lectura de un evento de Pesaje / Rotación / Veterinaria, con
 *  las mismas secciones que el formulario, mostradas solo si su flag está
 *  activo. Los nombres de los procedimientos se resuelven del catálogo en
 *  `connect()` (la response solo trae los ids). */
export class RotacionPesajeVeterinariaDetailRender implements IConnectRender {
  /** Id único de la instancia (para el contenedor de procedimientos). */
  private readonly _detailId: number;

  constructor(private readonly _evento: RotacionPesajeVeterinariaResponse) {
    ROTACION_PESAJE_VETERINARIA_DETAIL_ID += 1;
    this._detailId = ROTACION_PESAJE_VETERINARIA_DETAIL_ID;
  }

  render(): string {
    const e = this._evento;
    return mustache.render(template, {
      id: this._detailId,
      origen: e.loteOrigenNombre,
      fecha: e.fecha ? formatFechaCorta(e.fecha) : "—",
      cantidad: e.cantidadAnimales,
      withRotacion: e.isRotacion,
      destino: e.loteDestinoNombre ?? "—",
      withPesaje: e.isPesaje,
      pesos: e.pesosAnimales.map((peso, i) => ({
        n: i + 1,
        peso: _2d(peso),
      })),
      pesoMin: e.pesoMinimo != null ? `${_2d(e.pesoMinimo)} kg` : "—",
      pesoProm: e.pesoPromedio != null ? `${_2d(e.pesoPromedio)} kg` : "—",
      pesoMax: e.pesoMaximo != null ? `${_2d(e.pesoMaximo)} kg` : "—",
      pesoTotal: e.pesoTotal > 0 ? `${_miles(e.pesoTotal)} kg` : "—",
      withVeterinaria: e.isVeterinaria,
      observaciones: e.vetObservaciones ?? "",
    });
  }

  /** Resuelve los nombres de los procedimientos del catálogo (async). */
  connect(): void {
    if (!this._evento.isVeterinaria) return;
    void this._loadProcedimientos();
  }

  dispose(): void {
    this._disposed = true;
  }

  /** Si el detalle ya fue dispuesto (guarda de la carga async). */
  private _disposed = false;

  /** Carga el catálogo y pinta un badge por procedimiento aplicado. */
  private async _loadProcedimientos(): Promise<void> {
    const catalogo =
      await procedimientoVeterinarioGrpcCatalogService.getListAsync();
    const container = document.getElementById(
      `rpv-detail-procs-${this._detailId}`,
    );
    if (this._disposed || !container?.isConnected) return;

    container.innerHTML = "";
    this._evento.procedimientoIds.forEach((procId) => {
      const procedimiento = catalogo.find((p) => p.id === procId);
      const badge = document.createElement("span");
      badge.className = "sx-badge sx-badge-neutral";
      badge.textContent = procedimiento
        ? `${procedimiento.nombre}${procedimiento.isIca ? " · ICA" : ""}`
        : "—";
      container.appendChild(badge);
    });
  }
}
